import { dealInfoHelpers } from 'widget/player-widget';

export function isSubscribedTo(channel) {
  return Boolean(_.get(channel, 'dgsInfo.subscription'));
}

export function isSubscriptionEnabled(channel) {
  return Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo));
}



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/channel/pricing.js